import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes';
import { FontStyles } from './styles/global';

const App: React.FC = () => {
  return (
    <Router>
      <Routes />
      <FontStyles />
    </Router>
  );
};

export default App;
